import { getCurrencySymbol } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { FormatPricePipe } from '@epicuro-next/ataraxia/formatting';

const FORMATTER_CONFIG = {
  notation: 'compact',
  compactDisplay: 'short',
};

@Pipe({
  name: 'socialformatter',
  standalone: false,
})
export class SocialFormatterPipe implements PipeTransform {
  constructor(private formatPricePipe: FormatPricePipe) {}

  public transform(
    value: number,
    enabled: boolean,
    locale: string,
    currency?: string,
  ) {
    if (!enabled) {
      return value;
    }

    let result = Intl.NumberFormat(locale, {
      ...FORMATTER_CONFIG,
    } as unknown as Intl.NumberFormatOptions).format(value);

    if (currency) {
      result =
        this.formatPricePipe.transform(
          result,
          getCurrencySymbol(currency, 'wide'),
        ) ?? '';
    }

    return result;
  }
}
